import React from 'react';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';
import Rating from '../Rating';
import './styles.scss';

const RankingUser = ({ starSummary, className }) => (
    <ul className={classNames('header-stars', className)}>
        {Object.keys(starSummary).map((value, index) => (
            <li key={index}>
                <I18n k={`reviews.gigs._rating.${value}`} />
                <Rating score={starSummary[value]} />
            </li>
        ))}
    </ul>
);

export default RankingUser;
